import { el } from 'redom';

import SaveButton from 'generics/components/save-button';
import { TextInputBoxRow } from 'generics/components/text-input-row';
import AdvancedSettingsContainer from 'generics/components/advanced-settings-container';

import AdvancedFormSettings from './advanced-settings';

import {
  determineRedirectPathInputValue
} from './utilities';

class FormDetailsEditor {

  constructor(configuration, dialogConfiguration) {

    this.page = configuration.page;
    this.data = configuration.data;
    this.onSave = configuration.onSave;
    this.dialogConfiguration = dialogConfiguration;

    this.nameInputRow = null;
    this.submitButtonLabelInputRow = null;
    this.advancedFormSettings = new AdvancedFormSettings({
      detailsEditor: this,
      data: this.data,
      onChange: this.handleAdvancedFormSettingsChange.bind(this)
    });
    this.advancedSettingsSection = new AdvancedSettingsContainer({
      label: 'Advanced settings',
      content: this.advancedFormSettings
    });

    this.el = el('div.form-details-editor-main', [
      el('h3', 'Form details'),
      this.renderInputsSection(),
      this.renderControlsSection()
    ]);

  }

  renderInputsSection() {

    return el('.form-details-editor-inputs-section', [
      this.renderNameInputRow(),
      this.renderSubmitButtonLabelInputRow(),
      this.renderSuccessMessageInputRow(),
      this.renderRedirectPathInputRow(),
      this.advancedSettingsSection
    ]);

  }

  renderNameInputRow() {

    this.nameInputRow = new TextInputBoxRow({
      label: 'Name',
      placeholder: 'Contact us',
      value: this.data.name,
      onChange: this.handleNameInputChange.bind(this)
    });

    return this.nameInputRow;

  }

  renderSuccessMessageInputRow() {

    this.successMessageInputRow = new TextInputBoxRow({
      label: 'Success message',
      placeholder: 'Form submitted successfully!',
      value: this.data.successMessage,
      onChange: this.handleSuccessMessageInputChange.bind(this)
    });

    return this.successMessageInputRow;

  }

  renderSubmitButtonLabelInputRow() {

    this.submitButtonLabelInputRow = new TextInputBoxRow({
      label: 'Submit button label',
      placeholder: 'Submit',
      value: this.data.submitButtonLabel,
      onChange: this.handleSubmitButtonLabelInputChange.bind(this)
    });

    return this.submitButtonLabelInputRow;

  }

  renderRedirectPathInputRow() {

    this.redirectPathInputRow = new TextInputBoxRow({
      label: 'Redirect path',
      placeholder: '/path',
      value: determineRedirectPathInputValue(this.data.apiResponseHandler, this.data.page),
      onChange: this.handleRecirectPathChange.bind(this)
    });

    return this.redirectPathInputRow;

  }

  renderSaveButton() {

    const saveButton = new SaveButton({
      label: 'Save',
      onClick: this.handleSaveButtonClick.bind(this)
    });

    return saveButton;

  }

  renderControlsSection() {

    return el('.form-details-editor-controls-section', [
      el('.placeholder'),
      this.renderSaveButton()
    ]);

  }

  refreshRedirectPath() {

    const redirectPath = determineRedirectPathInputValue(this.data.apiResponseHandler, this.data.page);

    this.redirectPathInputRow.inputBox.setValue(redirectPath);

  }

  handleNameInputChange(event, name) {

    this.data.name = name;

  }

  handleSuccessMessageInputChange(event, successMessage) {

    this.data.successMessage = successMessage;

  }

  handleSubmitButtonLabelInputChange(event, label) {

    this.data.submitButtonLabel = label;

  }

  handleRecirectPathChange(event, redirectPath) {

    this.advancedFormSettings.buildAPIResponseHandlerForPath(redirectPath);

  }

  handleAdvancedFormSettingsChange(data) {

    this.data.apiEndpoint = data.apiEndpoint;
    this.data.forwardAuthorizationToken = data.forwardAuthorizationToken;
    this.data.apiResponseHandler = data.apiResponseHandler;
    this.data.notify = data.notify;

  }

  clearErrors() {

    this.nameInputRow.inputBox.clearError();

  }

  displayValidationErrors(errors) {

    for (let error of errors) {

      if (error.instancePath.indexOf('name') !== -1) {
        this.nameInputRow.inputBox.setError('Please enter name between 2-60 characters');
      }

    }

  }

  async handleSaveButtonClick() {

    this.clearErrors();

    try {

      await this.onSave(this.data, this.dialogConfiguration);

    } catch (exception) {

      if (exception.code !== 'ValidationError') {
        throw exception;
      }

      this.displayValidationErrors(exception.metadata);

    }

  }

  onmount() {

    this.nameInputRow.inputBox.focus();

  }

}

export default FormDetailsEditor;